import React, { useEffect, useState } from 'react';
import {
    Grid,
    Typography,
    TextField,
    IconButton,
    Box,
    Button,
    Paper,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { TrashIcon } from '../../icons';
import ValidationErrorText from '../../components/common/ValidationErrorText';

export const DEFAULT_SEMESTERS = [
    { year: 1, sem: 1, value: '' },
    { year: 1, sem: 2, value: '' },
    { year: 2, sem: 3, value: '' },
    { year: 2, sem: 4, value: '' },
];

const SemesterWiseCurriculum = ({ value, onChange, readOnly = false,fieldErrors,fieldError,fieldType }) => {
    const [semesters, setSemesters] = useState(
        Array.isArray(value) && value.length ? value : DEFAULT_SEMESTERS
    )

    useEffect(() => {
        if (Array.isArray(value)) setSemesters(value)
    }, [value])

    const updateSemesters = (newSemList) => {
        setSemesters(newSemList)
        onChange && onChange(newSemList)
    }

    const handleAddSemester = () => {
        const last = semesters[semesters?.length - 1];

        const newSem = {
            year:last ?  Math.floor((last.sem + 1) / 2) + ((last.sem + 1) % 2 === 0 ? 0 : 1) : 1,
            sem: last ? last.sem + 1 : 1,
            value: '',
        };
        updateSemesters([...semesters, newSem]);
    };


    const handleRemoveSemester = (index) => {
        const newSemList = semesters.filter((_, i) => i !== index)
        updateSemesters(newSemList)
    }


    const handleChange = (index, value) => {
        const newSemList = semesters.map((sem, i) =>
            i === index ? { ...sem, value } : sem
        )
        updateSemesters(newSemList)
    }

    const groupedByYear = semesters.reduce((acc, curr, index) => {
        acc[curr.year] = acc[curr.year] || [];
        acc[curr.year].push({ ...curr, index });
        return acc;
    }, {});

    return (
        <Box>
            {Object.entries(groupedByYear).map(([year, sems],indx) => (
                <Grid container spacing={2} key={year} alignItems="center" mb={1}>
                    <Grid size={{ xs: 12, md: 2 }}>
                        <Typography fontWeight={500}>Year {year}</Typography>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 10 }} >
                        <Grid container spacing={2}>
                            {sems.map((sem,index) => (
                                <Grid size={{ xs: 12, md: 6 }} key={sem.sem}>
                                    <Paper variant="outlined" sx={{ p: 2, position: 'relative', border: 'none', }}>
                                        <Typography variant="body2" fontWeight={600} gutterBottom>
                                            Semester {sem.sem}
                                        </Typography>
                                        <Box>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            multiline
                                            rows={3}
                                            placeholder={`Input Semester ${sem.sem} Details`}
                                            value={sem.value}
                                            onChange={(e) => handleChange(sem.index, e.target.value)}
                                            sx={{
                                                '& .MuiInputBase-input': { fontSize: '13px' },
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: '13px !important',
                                                    fontStyle: 'italic',
                                                    color: '#999999',
                                                }
                                            }}
                                            InputProps={{ readOnly }}
                                        />
                                        <ValidationErrorText error={fieldErrors?.[`${fieldType}[${index+indx*2}].value`]}/>
                                        </Box>


                                        {semesters.length > 4 && sem.index >= 4 && !readOnly && (
                                            <IconButton
                                                size="small"
                                                onClick={() => handleRemoveSemester(sem.index)}
                                                sx={{ position: 'absolute', top: 8, right: 8 }}
                                            >
                                                <TrashIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            ))}

            {!readOnly && (
                <Box mt={2}>
                    <Button
                        sx={{ color: '#1075FF', border: '1px solid #1075FF', px: 3 }}
                        startIcon={<AddIcon />}
                        onClick={handleAddSemester}
                    >
                        Add More
                    </Button>
                     <ValidationErrorText error={typeof fieldError==="string" && fieldError}/>
                </Box>
            )}
        </Box>
    );
};

export default SemesterWiseCurriculum;